// Auto-generated by @fermata/grpc-zustand - DO NOT EDIT
// Generated from: @proto/gen/devices/v1/service

import type {
  BatchGetDeviceEnrichmentDataRequest,
  BatchGetDeviceEnrichmentDataResponse,
  CreateConnectorRequest,
  CreateConnectorResponse,
  CreateDeviceErrorRequest,
  CreateDeviceErrorResponse,
  CreateDeviceRequest,
  CreateDeviceResponse,
  CreateEvseRequest,
  CreateEvseResponse,
  CreateStationRequest,
  CreateStationResponse,
  CreateStationaryBatteryRequest,
  CreateStationaryBatteryResponse,
  DeleteConnectorRequest,
  DeleteConnectorResponse,
  DeleteDeviceDefaultProfileRequest,
  DeleteDeviceDefaultProfileResponse,
  DeleteDeviceRequest,
  DeleteDeviceResponse,
  DeleteEvseRequest,
  DeleteEvseResponse,
  DeleteStationRequest,
  DeleteStationResponse,
  DeleteStationaryBatteryRequest,
  DeleteStationaryBatteryResponse,
  GetConnectorRequest,
  GetConnectorResponse,
  GetDeviceDefaultProfileRequest,
  GetDeviceDefaultProfileResponse,
  GetDeviceEnrichmentDataRequest,
  GetDeviceEnrichmentDataResponse,
  GetDeviceErrorRequest,
  GetDeviceErrorResponse,
  GetDeviceRequest,
  GetDeviceResponse,
  GetEvseRequest,
  GetEvseResponse,
  GetStationRequest,
  GetStationResponse,
  GetStationaryBatteryRequest,
  GetStationaryBatteryResponse,
  ListConnectorsRequest,
  ListConnectorsResponse,
  ListDeviceDefaultProfileHistoryRequest,
  ListDeviceDefaultProfileHistoryResponse,
  ListDeviceErrorsRequest,
  ListDeviceErrorsResponse,
  ListDevicesRequest,
  ListDevicesResponse,
  ListEvsesRequest,
  ListEvsesResponse,
  ListStationaryBatteriesRequest,
  ListStationaryBatteriesResponse,
  ListStationsRequest,
  ListStationsResponse,
  ResolveDeviceErrorRequest,
  ResolveDeviceErrorResponse,
  RestoreDeviceRequest,
  RestoreDeviceResponse,
  SetDeviceDefaultProfileRequest,
  SetDeviceDefaultProfileResponse,
  UpdateConnectorRequest,
  UpdateConnectorResponse,
  UpdateDeviceRequest,
  UpdateDeviceResponse,
  UpdateEvseRequest,
  UpdateEvseResponse,
  UpdateStationRequest,
  UpdateStationResponse,
  UpdateStationaryBatteryRequest,
  UpdateStationaryBatteryResponse,
} from "@proto/gen/devices/v1/service"
import { create } from "zustand"
import { devtools, persist, subscribeWithSelector } from "zustand/middleware"
import { createJSONStorage } from "zustand/middleware"
import { immer } from "zustand/middleware/immer"
import { createMethodState, requestKey } from "../../runtime/middleware"
import { boundedLocalStorage } from "../../runtime/storage"
import type { MethodState } from "../../runtime/types"
import { getDeviceClient } from "./client"

export interface DeviceServiceState {
  /** State for createDevice method */
  createDevice: MethodState<CreateDeviceResponse>
  /** State for getDevice method */
  getDevice: MethodState<GetDeviceResponse>
  /** State for listDevices method */
  listDevices: MethodState<ListDevicesResponse>
  /** State for updateDevice method */
  updateDevice: MethodState<UpdateDeviceResponse>
  /** State for deleteDevice method */
  deleteDevice: MethodState<DeleteDeviceResponse>
  /** State for restoreDevice method */
  restoreDevice: MethodState<RestoreDeviceResponse>
  /** State for getDeviceEnrichmentData method */
  getDeviceEnrichmentData: MethodState<GetDeviceEnrichmentDataResponse>
  /** State for batchGetDeviceEnrichmentData method */
  batchGetDeviceEnrichmentData: MethodState<BatchGetDeviceEnrichmentDataResponse>
  /** State for setDeviceDefaultProfile method */
  setDeviceDefaultProfile: MethodState<SetDeviceDefaultProfileResponse>
  /** State for getDeviceDefaultProfile method */
  getDeviceDefaultProfile: MethodState<GetDeviceDefaultProfileResponse>
  /** State for deleteDeviceDefaultProfile method */
  deleteDeviceDefaultProfile: MethodState<DeleteDeviceDefaultProfileResponse>
  /** State for listDeviceDefaultProfileHistory method */
  listDeviceDefaultProfileHistory: MethodState<ListDeviceDefaultProfileHistoryResponse>
  /** State for createStation method */
  createStation: MethodState<CreateStationResponse>
  /** State for getStation method */
  getStation: MethodState<GetStationResponse>
  /** State for listStations method */
  listStations: MethodState<ListStationsResponse>
  /** State for updateStation method */
  updateStation: MethodState<UpdateStationResponse>
  /** State for deleteStation method */
  deleteStation: MethodState<DeleteStationResponse>
  /** State for createEvse method */
  createEvse: MethodState<CreateEvseResponse>
  /** State for getEvse method */
  getEvse: MethodState<GetEvseResponse>
  /** State for listEvses method */
  listEvses: MethodState<ListEvsesResponse>
  /** State for updateEvse method */
  updateEvse: MethodState<UpdateEvseResponse>
  /** State for deleteEvse method */
  deleteEvse: MethodState<DeleteEvseResponse>
  /** State for createConnector method */
  createConnector: MethodState<CreateConnectorResponse>
  /** State for getConnector method */
  getConnector: MethodState<GetConnectorResponse>
  /** State for listConnectors method */
  listConnectors: MethodState<ListConnectorsResponse>
  /** State for updateConnector method */
  updateConnector: MethodState<UpdateConnectorResponse>
  /** State for deleteConnector method */
  deleteConnector: MethodState<DeleteConnectorResponse>
  /** State for createStationaryBattery method */
  createStationaryBattery: MethodState<CreateStationaryBatteryResponse>
  /** State for getStationaryBattery method */
  getStationaryBattery: MethodState<GetStationaryBatteryResponse>
  /** State for listStationaryBatteries method */
  listStationaryBatteries: MethodState<ListStationaryBatteriesResponse>
  /** State for updateStationaryBattery method */
  updateStationaryBattery: MethodState<UpdateStationaryBatteryResponse>
  /** State for deleteStationaryBattery method */
  deleteStationaryBattery: MethodState<DeleteStationaryBatteryResponse>
  /** State for createDeviceError method */
  createDeviceError: MethodState<CreateDeviceErrorResponse>
  /** State for getDeviceError method */
  getDeviceError: MethodState<GetDeviceErrorResponse>
  /** State for listDeviceErrors method */
  listDeviceErrors: MethodState<ListDeviceErrorsResponse>
  /** State for resolveDeviceError method */
  resolveDeviceError: MethodState<ResolveDeviceErrorResponse>
  /** Call createDevice method */
  createDeviceAsync: (req: CreateDeviceRequest) => Promise<CreateDeviceResponse>
  /** Call getDevice method */
  getDeviceAsync: (req: GetDeviceRequest) => Promise<GetDeviceResponse>
  /** Call listDevices method */
  listDevicesAsync: (req: ListDevicesRequest) => Promise<ListDevicesResponse>
  /** Call updateDevice method */
  updateDeviceAsync: (req: UpdateDeviceRequest) => Promise<UpdateDeviceResponse>
  /** Call deleteDevice method */
  deleteDeviceAsync: (req: DeleteDeviceRequest) => Promise<DeleteDeviceResponse>
  /** Call restoreDevice method */
  restoreDeviceAsync: (req: RestoreDeviceRequest) => Promise<RestoreDeviceResponse>
  /** Call getDeviceEnrichmentData method */
  getDeviceEnrichmentDataAsync: (
    req: GetDeviceEnrichmentDataRequest
  ) => Promise<GetDeviceEnrichmentDataResponse>
  /** Call batchGetDeviceEnrichmentData method */
  batchGetDeviceEnrichmentDataAsync: (
    req: BatchGetDeviceEnrichmentDataRequest
  ) => Promise<BatchGetDeviceEnrichmentDataResponse>
  /** Call setDeviceDefaultProfile method */
  setDeviceDefaultProfileAsync: (
    req: SetDeviceDefaultProfileRequest
  ) => Promise<SetDeviceDefaultProfileResponse>
  /** Call getDeviceDefaultProfile method */
  getDeviceDefaultProfileAsync: (
    req: GetDeviceDefaultProfileRequest
  ) => Promise<GetDeviceDefaultProfileResponse>
  /** Call deleteDeviceDefaultProfile method */
  deleteDeviceDefaultProfileAsync: (
    req: DeleteDeviceDefaultProfileRequest
  ) => Promise<DeleteDeviceDefaultProfileResponse>
  /** Call listDeviceDefaultProfileHistory method */
  listDeviceDefaultProfileHistoryAsync: (
    req: ListDeviceDefaultProfileHistoryRequest
  ) => Promise<ListDeviceDefaultProfileHistoryResponse>
  /** Call createStation method */
  createStationAsync: (req: CreateStationRequest) => Promise<CreateStationResponse>
  /** Call getStation method */
  getStationAsync: (req: GetStationRequest) => Promise<GetStationResponse>
  /** Call listStations method */
  listStationsAsync: (req: ListStationsRequest) => Promise<ListStationsResponse>
  /** Call updateStation method */
  updateStationAsync: (req: UpdateStationRequest) => Promise<UpdateStationResponse>
  /** Call deleteStation method */
  deleteStationAsync: (req: DeleteStationRequest) => Promise<DeleteStationResponse>
  /** Call createEvse method */
  createEvseAsync: (req: CreateEvseRequest) => Promise<CreateEvseResponse>
  /** Call getEvse method */
  getEvseAsync: (req: GetEvseRequest) => Promise<GetEvseResponse>
  /** Call listEvses method */
  listEvsesAsync: (req: ListEvsesRequest) => Promise<ListEvsesResponse>
  /** Call updateEvse method */
  updateEvseAsync: (req: UpdateEvseRequest) => Promise<UpdateEvseResponse>
  /** Call deleteEvse method */
  deleteEvseAsync: (req: DeleteEvseRequest) => Promise<DeleteEvseResponse>
  /** Call createConnector method */
  createConnectorAsync: (req: CreateConnectorRequest) => Promise<CreateConnectorResponse>
  /** Call getConnector method */
  getConnectorAsync: (req: GetConnectorRequest) => Promise<GetConnectorResponse>
  /** Call listConnectors method */
  listConnectorsAsync: (req: ListConnectorsRequest) => Promise<ListConnectorsResponse>
  /** Call updateConnector method */
  updateConnectorAsync: (req: UpdateConnectorRequest) => Promise<UpdateConnectorResponse>
  /** Call deleteConnector method */
  deleteConnectorAsync: (req: DeleteConnectorRequest) => Promise<DeleteConnectorResponse>
  /** Call createStationaryBattery method */
  createStationaryBatteryAsync: (
    req: CreateStationaryBatteryRequest
  ) => Promise<CreateStationaryBatteryResponse>
  /** Call getStationaryBattery method */
  getStationaryBatteryAsync: (
    req: GetStationaryBatteryRequest
  ) => Promise<GetStationaryBatteryResponse>
  /** Call listStationaryBatteries method */
  listStationaryBatteriesAsync: (
    req: ListStationaryBatteriesRequest
  ) => Promise<ListStationaryBatteriesResponse>
  /** Call updateStationaryBattery method */
  updateStationaryBatteryAsync: (
    req: UpdateStationaryBatteryRequest
  ) => Promise<UpdateStationaryBatteryResponse>
  /** Call deleteStationaryBattery method */
  deleteStationaryBatteryAsync: (
    req: DeleteStationaryBatteryRequest
  ) => Promise<DeleteStationaryBatteryResponse>
  /** Call createDeviceError method */
  createDeviceErrorAsync: (req: CreateDeviceErrorRequest) => Promise<CreateDeviceErrorResponse>
  /** Call getDeviceError method */
  getDeviceErrorAsync: (req: GetDeviceErrorRequest) => Promise<GetDeviceErrorResponse>
  /** Call listDeviceErrors method */
  listDeviceErrorsAsync: (req: ListDeviceErrorsRequest) => Promise<ListDeviceErrorsResponse>
  /** Call resolveDeviceError method */
  resolveDeviceErrorAsync: (req: ResolveDeviceErrorRequest) => Promise<ResolveDeviceErrorResponse>
}

/**
 * Zustand store for DeviceService
 *
 * Features:
 * - Auto-manages loading/error states per method
 * - Supports fine-grained reactivity with subscribeWithSelector
 * - Optional persistence to localStorage
 * - Redux DevTools integration
 */
export const useDeviceServiceStore = create<DeviceServiceState>()(
  devtools(
    persist(
      subscribeWithSelector(
        immer((set) => ({
          createDevice: createMethodState<CreateDeviceResponse>(),
          async createDeviceAsync(req: CreateDeviceRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.createDevice
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getDeviceClient().createDevice(req)
              set((state) => {
                const slot = state.createDevice
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.createDevice
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          getDevice: createMethodState<GetDeviceResponse>(),
          async getDeviceAsync(req: GetDeviceRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.getDevice
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getDeviceClient().getDevice(req)
              set((state) => {
                const slot = state.getDevice
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.getDevice
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          listDevices: createMethodState<ListDevicesResponse>(),
          async listDevicesAsync(req: ListDevicesRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.listDevices
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getDeviceClient().listDevices(req)
              set((state) => {
                const slot = state.listDevices
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.listDevices
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          updateDevice: createMethodState<UpdateDeviceResponse>(),
          async updateDeviceAsync(req: UpdateDeviceRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.updateDevice
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getDeviceClient().updateDevice(req)
              set((state) => {
                const slot = state.updateDevice
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.updateDevice
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          deleteDevice: createMethodState<DeleteDeviceResponse>(),
          async deleteDeviceAsync(req: DeleteDeviceRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.deleteDevice
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getDeviceClient().deleteDevice(req)
              set((state) => {
                const slot = state.deleteDevice
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.deleteDevice
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          restoreDevice: createMethodState<RestoreDeviceResponse>(),
          async restoreDeviceAsync(req: RestoreDeviceRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.restoreDevice
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getDeviceClient().restoreDevice(req)
              set((state) => {
                const slot = state.restoreDevice
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.restoreDevice
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          getDeviceEnrichmentData: createMethodState<GetDeviceEnrichmentDataResponse>(),
          async getDeviceEnrichmentDataAsync(req: GetDeviceEnrichmentDataRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.getDeviceEnrichmentData
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getDeviceClient().getDeviceEnrichmentData(req)
              set((state) => {
                const slot = state.getDeviceEnrichmentData
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.getDeviceEnrichmentData
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          batchGetDeviceEnrichmentData: createMethodState<BatchGetDeviceEnrichmentDataResponse>(),
          async batchGetDeviceEnrichmentDataAsync(req: BatchGetDeviceEnrichmentDataRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.batchGetDeviceEnrichmentData
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getDeviceClient().batchGetDeviceEnrichmentData(req)
              set((state) => {
                const slot = state.batchGetDeviceEnrichmentData
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.batchGetDeviceEnrichmentData
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          setDeviceDefaultProfile: createMethodState<SetDeviceDefaultProfileResponse>(),
          async setDeviceDefaultProfileAsync(req: SetDeviceDefaultProfileRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.setDeviceDefaultProfile
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getDeviceClient().setDeviceDefaultProfile(req)
              set((state) => {
                const slot = state.setDeviceDefaultProfile
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.setDeviceDefaultProfile
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          getDeviceDefaultProfile: createMethodState<GetDeviceDefaultProfileResponse>(),
          async getDeviceDefaultProfileAsync(req: GetDeviceDefaultProfileRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.getDeviceDefaultProfile
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getDeviceClient().getDeviceDefaultProfile(req)
              set((state) => {
                const slot = state.getDeviceDefaultProfile
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.getDeviceDefaultProfile
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          deleteDeviceDefaultProfile: createMethodState<DeleteDeviceDefaultProfileResponse>(),
          async deleteDeviceDefaultProfileAsync(req: DeleteDeviceDefaultProfileRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.deleteDeviceDefaultProfile
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getDeviceClient().deleteDeviceDefaultProfile(req)
              set((state) => {
                const slot = state.deleteDeviceDefaultProfile
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.deleteDeviceDefaultProfile
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          listDeviceDefaultProfileHistory:
            createMethodState<ListDeviceDefaultProfileHistoryResponse>(),
          async listDeviceDefaultProfileHistoryAsync(req: ListDeviceDefaultProfileHistoryRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.listDeviceDefaultProfileHistory
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getDeviceClient().listDeviceDefaultProfileHistory(req)
              set((state) => {
                const slot = state.listDeviceDefaultProfileHistory
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.listDeviceDefaultProfileHistory
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          createStation: createMethodState<CreateStationResponse>(),
          async createStationAsync(req: CreateStationRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.createStation
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getDeviceClient().createStation(req)
              set((state) => {
                const slot = state.createStation
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.createStation
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          getStation: createMethodState<GetStationResponse>(),
          async getStationAsync(req: GetStationRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.getStation
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getDeviceClient().getStation(req)
              set((state) => {
                const slot = state.getStation
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.getStation
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          listStations: createMethodState<ListStationsResponse>(),
          async listStationsAsync(req: ListStationsRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.listStations
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getDeviceClient().listStations(req)
              set((state) => {
                const slot = state.listStations
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.listStations
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          updateStation: createMethodState<UpdateStationResponse>(),
          async updateStationAsync(req: UpdateStationRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.updateStation
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getDeviceClient().updateStation(req)
              set((state) => {
                const slot = state.updateStation
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.updateStation
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          deleteStation: createMethodState<DeleteStationResponse>(),
          async deleteStationAsync(req: DeleteStationRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.deleteStation
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getDeviceClient().deleteStation(req)
              set((state) => {
                const slot = state.deleteStation
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.deleteStation
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          createEvse: createMethodState<CreateEvseResponse>(),
          async createEvseAsync(req: CreateEvseRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.createEvse
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getDeviceClient().createEvse(req)
              set((state) => {
                const slot = state.createEvse
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.createEvse
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          getEvse: createMethodState<GetEvseResponse>(),
          async getEvseAsync(req: GetEvseRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.getEvse
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getDeviceClient().getEvse(req)
              set((state) => {
                const slot = state.getEvse
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.getEvse
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          listEvses: createMethodState<ListEvsesResponse>(),
          async listEvsesAsync(req: ListEvsesRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.listEvses
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getDeviceClient().listEvses(req)
              set((state) => {
                const slot = state.listEvses
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.listEvses
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          updateEvse: createMethodState<UpdateEvseResponse>(),
          async updateEvseAsync(req: UpdateEvseRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.updateEvse
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getDeviceClient().updateEvse(req)
              set((state) => {
                const slot = state.updateEvse
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.updateEvse
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          deleteEvse: createMethodState<DeleteEvseResponse>(),
          async deleteEvseAsync(req: DeleteEvseRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.deleteEvse
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getDeviceClient().deleteEvse(req)
              set((state) => {
                const slot = state.deleteEvse
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.deleteEvse
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          createConnector: createMethodState<CreateConnectorResponse>(),
          async createConnectorAsync(req: CreateConnectorRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.createConnector
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getDeviceClient().createConnector(req)
              set((state) => {
                const slot = state.createConnector
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.createConnector
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          getConnector: createMethodState<GetConnectorResponse>(),
          async getConnectorAsync(req: GetConnectorRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.getConnector
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getDeviceClient().getConnector(req)
              set((state) => {
                const slot = state.getConnector
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.getConnector
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          listConnectors: createMethodState<ListConnectorsResponse>(),
          async listConnectorsAsync(req: ListConnectorsRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.listConnectors
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getDeviceClient().listConnectors(req)
              set((state) => {
                const slot = state.listConnectors
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.listConnectors
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          updateConnector: createMethodState<UpdateConnectorResponse>(),
          async updateConnectorAsync(req: UpdateConnectorRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.updateConnector
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getDeviceClient().updateConnector(req)
              set((state) => {
                const slot = state.updateConnector
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.updateConnector
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          deleteConnector: createMethodState<DeleteConnectorResponse>(),
          async deleteConnectorAsync(req: DeleteConnectorRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.deleteConnector
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getDeviceClient().deleteConnector(req)
              set((state) => {
                const slot = state.deleteConnector
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.deleteConnector
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          createStationaryBattery: createMethodState<CreateStationaryBatteryResponse>(),
          async createStationaryBatteryAsync(req: CreateStationaryBatteryRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.createStationaryBattery
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getDeviceClient().createStationaryBattery(req)
              set((state) => {
                const slot = state.createStationaryBattery
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.createStationaryBattery
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          getStationaryBattery: createMethodState<GetStationaryBatteryResponse>(),
          async getStationaryBatteryAsync(req: GetStationaryBatteryRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.getStationaryBattery
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getDeviceClient().getStationaryBattery(req)
              set((state) => {
                const slot = state.getStationaryBattery
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.getStationaryBattery
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          listStationaryBatteries: createMethodState<ListStationaryBatteriesResponse>(),
          async listStationaryBatteriesAsync(req: ListStationaryBatteriesRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.listStationaryBatteries
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getDeviceClient().listStationaryBatteries(req)
              set((state) => {
                const slot = state.listStationaryBatteries
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.listStationaryBatteries
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          updateStationaryBattery: createMethodState<UpdateStationaryBatteryResponse>(),
          async updateStationaryBatteryAsync(req: UpdateStationaryBatteryRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.updateStationaryBattery
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getDeviceClient().updateStationaryBattery(req)
              set((state) => {
                const slot = state.updateStationaryBattery
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.updateStationaryBattery
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          deleteStationaryBattery: createMethodState<DeleteStationaryBatteryResponse>(),
          async deleteStationaryBatteryAsync(req: DeleteStationaryBatteryRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.deleteStationaryBattery
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getDeviceClient().deleteStationaryBattery(req)
              set((state) => {
                const slot = state.deleteStationaryBattery
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.deleteStationaryBattery
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          createDeviceError: createMethodState<CreateDeviceErrorResponse>(),
          async createDeviceErrorAsync(req: CreateDeviceErrorRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.createDeviceError
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getDeviceClient().createDeviceError(req)
              set((state) => {
                const slot = state.createDeviceError
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.createDeviceError
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          getDeviceError: createMethodState<GetDeviceErrorResponse>(),
          async getDeviceErrorAsync(req: GetDeviceErrorRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.getDeviceError
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getDeviceClient().getDeviceError(req)
              set((state) => {
                const slot = state.getDeviceError
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.getDeviceError
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          listDeviceErrors: createMethodState<ListDeviceErrorsResponse>(),
          async listDeviceErrorsAsync(req: ListDeviceErrorsRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.listDeviceErrors
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getDeviceClient().listDeviceErrors(req)
              set((state) => {
                const slot = state.listDeviceErrors
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.listDeviceErrors
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          resolveDeviceError: createMethodState<ResolveDeviceErrorResponse>(),
          async resolveDeviceErrorAsync(req: ResolveDeviceErrorRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.resolveDeviceError
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getDeviceClient().resolveDeviceError(req)
              set((state) => {
                const slot = state.resolveDeviceError
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.resolveDeviceError
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
        }))
      ),
      {
        name: "device-store",
        // Bounded, non-throwing localStorage (see runtime/storage.ts): an
        // oversized or failing cache write is dropped rather than surfaced,
        // so it can never abort an unrelated store action.
        storage: createJSONStorage(() => boundedLocalStorage, {
          replacer: (key, value) => {
            // Convert BigInt to string for JSON serialization
            if (typeof value === "bigint") {
              return value.toString()
            }
            return value
          },
          reviver: (key, value) => {
            // Optionally convert string back to BigInt on deserialization
            // (but keeping as string is usually fine for display)
            return value
          },
        }),
        partialize: (state) => {
          // Only persist data, not loading/error states
          const persistedState: Partial<DeviceServiceState> = {}
          {
            const slot = state.createDevice
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.createDevice = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<CreateDeviceResponse>
            }
          }
          {
            const slot = state.getDevice
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.getDevice = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<GetDeviceResponse>
            }
          }
          {
            const slot = state.listDevices
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.listDevices = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<ListDevicesResponse>
            }
          }
          {
            const slot = state.updateDevice
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.updateDevice = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<UpdateDeviceResponse>
            }
          }
          {
            const slot = state.deleteDevice
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.deleteDevice = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<DeleteDeviceResponse>
            }
          }
          {
            const slot = state.restoreDevice
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.restoreDevice = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<RestoreDeviceResponse>
            }
          }
          {
            const slot = state.getDeviceEnrichmentData
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.getDeviceEnrichmentData = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<GetDeviceEnrichmentDataResponse>
            }
          }
          {
            const slot = state.batchGetDeviceEnrichmentData
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.batchGetDeviceEnrichmentData = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<BatchGetDeviceEnrichmentDataResponse>
            }
          }
          {
            const slot = state.setDeviceDefaultProfile
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.setDeviceDefaultProfile = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<SetDeviceDefaultProfileResponse>
            }
          }
          {
            const slot = state.getDeviceDefaultProfile
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.getDeviceDefaultProfile = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<GetDeviceDefaultProfileResponse>
            }
          }
          {
            const slot = state.deleteDeviceDefaultProfile
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.deleteDeviceDefaultProfile = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<DeleteDeviceDefaultProfileResponse>
            }
          }
          {
            const slot = state.listDeviceDefaultProfileHistory
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.listDeviceDefaultProfileHistory = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<ListDeviceDefaultProfileHistoryResponse>
            }
          }
          {
            const slot = state.createStation
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.createStation = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<CreateStationResponse>
            }
          }
          {
            const slot = state.getStation
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.getStation = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<GetStationResponse>
            }
          }
          {
            const slot = state.listStations
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.listStations = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<ListStationsResponse>
            }
          }
          {
            const slot = state.updateStation
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.updateStation = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<UpdateStationResponse>
            }
          }
          {
            const slot = state.deleteStation
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.deleteStation = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<DeleteStationResponse>
            }
          }
          {
            const slot = state.createEvse
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.createEvse = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<CreateEvseResponse>
            }
          }
          {
            const slot = state.getEvse
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.getEvse = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<GetEvseResponse>
            }
          }
          {
            const slot = state.listEvses
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.listEvses = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<ListEvsesResponse>
            }
          }
          {
            const slot = state.updateEvse
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.updateEvse = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<UpdateEvseResponse>
            }
          }
          {
            const slot = state.deleteEvse
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.deleteEvse = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<DeleteEvseResponse>
            }
          }
          {
            const slot = state.createConnector
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.createConnector = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<CreateConnectorResponse>
            }
          }
          {
            const slot = state.getConnector
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.getConnector = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<GetConnectorResponse>
            }
          }
          {
            const slot = state.listConnectors
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.listConnectors = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<ListConnectorsResponse>
            }
          }
          {
            const slot = state.updateConnector
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.updateConnector = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<UpdateConnectorResponse>
            }
          }
          {
            const slot = state.deleteConnector
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.deleteConnector = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<DeleteConnectorResponse>
            }
          }
          {
            const slot = state.createStationaryBattery
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.createStationaryBattery = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<CreateStationaryBatteryResponse>
            }
          }
          {
            const slot = state.getStationaryBattery
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.getStationaryBattery = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<GetStationaryBatteryResponse>
            }
          }
          {
            const slot = state.listStationaryBatteries
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.listStationaryBatteries = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<ListStationaryBatteriesResponse>
            }
          }
          {
            const slot = state.updateStationaryBattery
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.updateStationaryBattery = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<UpdateStationaryBatteryResponse>
            }
          }
          {
            const slot = state.deleteStationaryBattery
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.deleteStationaryBattery = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<DeleteStationaryBatteryResponse>
            }
          }
          {
            const slot = state.createDeviceError
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.createDeviceError = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<CreateDeviceErrorResponse>
            }
          }
          {
            const slot = state.getDeviceError
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.getDeviceError = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<GetDeviceErrorResponse>
            }
          }
          {
            const slot = state.listDeviceErrors
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.listDeviceErrors = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<ListDeviceErrorsResponse>
            }
          }
          {
            const slot = state.resolveDeviceError
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.resolveDeviceError = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<ResolveDeviceErrorResponse>
            }
          }
          return persistedState
        },
        // Persisted state written before request-keyed caching lacks `byKey`.
        // The default shallow merge replaces each method slot wholesale, which
        // would drop the freshly-initialized `byKey` map and make reads/writes
        // to `byKey[...]` throw. Re-add `byKey` for any rehydrated slot, and
        // surface any legacy top-level `data` under the no-request key so
        // no-arg hooks (the only request shape we can reconstruct) still see it
        // instead of `undefined`. Keyed reads for other requests fall through
        // to a fresh fetch, so we never serve one request's data for another.
        merge: (persisted, current) => {
          const merged = { ...current, ...(persisted as object) } as DeviceServiceState
          for (const slot of Object.values(merged as unknown as Record<string, unknown>)) {
            if (
              slot &&
              typeof slot === "object" &&
              "data" in slot &&
              !("byKey" in (slot as object))
            ) {
              const s = slot as unknown as { data: unknown; byKey: Record<string, unknown> }
              s.byKey =
                s.data !== undefined
                  ? { [requestKey(undefined)]: { data: s.data, loading: false, error: undefined } }
                  : {}
            }
          }
          return merged
        },
      }
    ),
    { name: "DeviceService" }
  )
)
